import React from 'react';

const PROGRAMS = [
    'LIHTC', 'Section 8', 'Section 202', 'Section 811', 'HOME',
    'PBRA', 'RAD', 'USDA-RD', 'Public Housing', 'HTF', 'SAIL',
];

/**
 * Multi-select program chips. Properties can participate in more than one
 * program — a LIHTC property can also be Section 8 + HOME layered.
 */
export default function ProgramChips({ value = [], onChange, disabled = false }) {
    const toggle = (p) => {
        const set = new Set(value);
        set.has(p) ? set.delete(p) : set.add(p);
        onChange?.(Array.from(set));
    };

    return (
        <div className="flex flex-wrap gap-1.5">
            {PROGRAMS.map((p) => {
                const active = value.includes(p);
                return (
                    <button
                        key={p}
                        type="button"
                        disabled={disabled}
                        onClick={() => toggle(p)}
                        className={`px-3 py-1.5 rounded-full text-xs font-medium transition-all duration-150 border
                                    ${active
                                        ? 'bg-blue-600 text-white border-blue-600 shadow-sm hover:bg-blue-700'
                                        : 'bg-white dark:bg-slate-900 text-slate-700 dark:text-slate-200 border-slate-300 dark:border-slate-700 hover:border-blue-400 hover:text-blue-600 dark:hover:text-blue-400'}`}>
                        {p}
                    </button>
                );
            })}
        </div>
    );
}
